'use strict';

var i18n;

i18n = require('../utils/i18n.coffee');

module.exports = function () {
  return riot.mixin('i18n', new i18n());
};